import { TPairApiDto } from '../api.types'

export const getPairsApiRespMock: TPairApiDto[] = [
    {
        name: 'OMGDOGE',
        base: 'OMG',
        quote: 'DOGE',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'NANOXMR',
        base: 'NANO',
        quote: 'XMR',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'ZECCAD',
        base: 'ZEC',
        quote: 'CAD',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'LTCNEO',
        base: 'LTC',
        quote: 'NEO',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BTCNEO',
        base: 'BTC',
        quote: 'NEO',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XRPNEO',
        base: 'XRP',
        quote: 'NEO',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BCHNEO',
        base: 'BCH',
        quote: 'NEO',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XVGNEO',
        base: 'XVG',
        quote: 'NEO',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'ETHNEO',
        base: 'ETH',
        quote: 'NEO',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XMRDOGE',
        base: 'XMR',
        quote: 'DOGE',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'LTCCAD',
        base: 'LTC',
        quote: 'CAD',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'OMGBDG',
        base: 'OMG',
        quote: 'BDG',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BNTKNC',
        base: 'BNT',
        quote: 'KNC',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BIXBNT',
        base: 'BIX',
        quote: 'BNT',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BNTRUB',
        base: 'BNT',
        quote: 'RUB',
        fee_ask: '0.09000000',
        fee_bid: '0.09000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XMRDASH',
        base: 'XMR',
        quote: 'DASH',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XVGJPY',
        base: 'XVG',
        quote: 'JPY',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BCHDASH',
        base: 'BCH',
        quote: 'DASH',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XMRXVG',
        base: 'XMR',
        quote: 'XVG',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XRPXMR',
        base: 'XRP',
        quote: 'XMR',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'DASHAUD',
        base: 'DASH',
        quote: 'AUD',
        fee_ask: '0.07000000',
        fee_bid: '0.07000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'LTCDOGE',
        base: 'LTC',
        quote: 'DOGE',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'NEOAUD',
        base: 'NEO',
        quote: 'AUD',
        fee_ask: '0.07000000',
        fee_bid: '0.07000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'OMGRUB',
        base: 'OMG',
        quote: 'RUB',
        fee_ask: '0.09000000',
        fee_bid: '0.09000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'NANODOGE',
        base: 'NANO',
        quote: 'DOGE',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XLMAUD',
        base: 'XLM',
        quote: 'AUD',
        fee_ask: '0.07000000',
        fee_bid: '0.07000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'KCSUSDT',
        base: 'KCS',
        quote: 'USDT',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'KNCUSDT',
        base: 'KNC',
        quote: 'USDT',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XLMEUR',
        base: 'XLM',
        quote: 'EUR',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XLMUSD',
        base: 'XLM',
        quote: 'USD',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BNTUSD',
        base: 'BNT',
        quote: 'USD',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'KCSUSD',
        base: 'KCS',
        quote: 'USD',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BIXUSDT',
        base: 'BIX',
        quote: 'USDT',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BIXXRP',
        base: 'BIX',
        quote: 'XRP',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'HTBIX',
        base: 'HT',
        quote: 'BIX',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XLMBIX',
        base: 'XLM',
        quote: 'BIX',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'NEOBIX',
        base: 'NEO',
        quote: 'BIX',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BNTBIX',
        base: 'BNT',
        quote: 'BIX',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'NEOEUR',
        base: 'NEO',
        quote: 'EUR',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BDGAUD',
        base: 'BDG',
        quote: 'AUD',
        fee_ask: '0.07000000',
        fee_bid: '0.07000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BDGDOGE',
        base: 'BDG',
        quote: 'DOGE',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BDGXMR',
        base: 'BDG',
        quote: 'XMR',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'OMGAUD',
        base: 'OMG',
        quote: 'AUD',
        fee_ask: '0.07000000',
        fee_bid: '0.07000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'ZECDOGE',
        base: 'ZEC',
        quote: 'DOGE',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'DOGEEUR',
        base: 'DOGE',
        quote: 'EUR',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XRPZEC',
        base: 'XRP',
        quote: 'ZEC',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'LTCBIX',
        base: 'LTC',
        quote: 'BIX',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BIXLTC',
        base: 'BIX',
        quote: 'LTC',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'HTUSDT',
        base: 'HT',
        quote: 'USDT',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BNTUSDT',
        base: 'BNT',
        quote: 'USDT',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'HTXRP',
        base: 'HT',
        quote: 'XRP',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'HTXVG',
        base: 'HT',
        quote: 'XVG',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'HTDASH',
        base: 'HT',
        quote: 'DASH',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BNTDASH',
        base: 'BNT',
        quote: 'DASH',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XMRBNT',
        base: 'XMR',
        quote: 'BNT',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'LTCBNT',
        base: 'LTC',
        quote: 'BNT',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'USDTBNT',
        base: 'USDT',
        quote: 'BNT',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'NEOUSDT',
        base: 'NEO',
        quote: 'USDT',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'ZECXMR',
        base: 'ZEC',
        quote: 'XMR',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XMRGBP',
        base: 'XMR',
        quote: 'GBP',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XMRJPY',
        base: 'XMR',
        quote: 'JPY',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XRPJPY',
        base: 'XRP',
        quote: 'JPY',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'DASHGBP',
        base: 'DASH',
        quote: 'GBP',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BCHJPY',
        base: 'BCH',
        quote: 'JPY',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'OMGBIX',
        base: 'OMG',
        quote: 'BIX',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'OMGBNT',
        base: 'OMG',
        quote: 'BNT',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'OMGHT',
        base: 'OMG',
        quote: 'HT',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BDGNANO',
        base: 'BDG',
        quote: 'NANO',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XLMNANO',
        base: 'XLM',
        quote: 'NANO',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'NEOUSD',
        base: 'NEO',
        quote: 'USD',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'DASHXLM',
        base: 'DASH',
        quote: 'XLM',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'OMGLTC',
        base: 'OMG',
        quote: 'LTC',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'OMGXMR',
        base: 'OMG',
        quote: 'XMR',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BNTLTC',
        base: 'BNT',
        quote: 'LTC',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'KNCLTC',
        base: 'KNC',
        quote: 'LTC',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BNTXMR',
        base: 'BNT',
        quote: 'XMR',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BIXXMR',
        base: 'BIX',
        quote: 'XMR',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'KNCXMR',
        base: 'KNC',
        quote: 'XMR',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'KCSXMR',
        base: 'KCS',
        quote: 'XMR',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BNTDOGE',
        base: 'BNT',
        quote: 'DOGE',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BIXDOGE',
        base: 'BIX',
        quote: 'DOGE',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'KNCDOGE',
        base: 'KNC',
        quote: 'DOGE',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'KCSDOGE',
        base: 'KCS',
        quote: 'DOGE',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BIXEUR',
        base: 'BIX',
        quote: 'EUR',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'KNCEUR',
        base: 'KNC',
        quote: 'EUR',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'KNCUSD',
        base: 'KNC',
        quote: 'USD',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BIXDASH',
        base: 'BIX',
        quote: 'DASH',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'KNCDASH',
        base: 'KNC',
        quote: 'DASH',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'KCSDASH',
        base: 'KCS',
        quote: 'DASH',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'KNCJPY',
        base: 'KNC',
        quote: 'JPY',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BNTNEO',
        base: 'BNT',
        quote: 'NEO',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'KNCNEO',
        base: 'KNC',
        quote: 'NEO',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'ZECBTC',
        base: 'ZEC',
        quote: 'BTC',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'LTCKNC',
        base: 'LTC',
        quote: 'KNC',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'ZECNEO',
        base: 'ZEC',
        quote: 'NEO',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XMRBCH',
        base: 'XMR',
        quote: 'BCH',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XMRUSDT',
        base: 'XMR',
        quote: 'USDT',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'USDTDOGE',
        base: 'USDT',
        quote: 'DOGE',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'USDTAUD',
        base: 'USDT',
        quote: 'AUD',
        fee_ask: '0.07000000',
        fee_bid: '0.07000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'USDTJPY',
        base: 'USDT',
        quote: 'JPY',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XRPLTC',
        base: 'XRP',
        quote: 'LTC',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'KCSLTC',
        base: 'KCS',
        quote: 'LTC',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'KCSEUR',
        base: 'KCS',
        quote: 'EUR',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XMRKCS',
        base: 'XMR',
        quote: 'KCS',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'USDTBIX',
        base: 'USDT',
        quote: 'BIX',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'LTCHT',
        base: 'LTC',
        quote: 'HT',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'USDTHT',
        base: 'USDT',
        quote: 'HT',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XMRHT',
        base: 'XMR',
        quote: 'HT',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XMRNEO',
        base: 'XMR',
        quote: 'NEO',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XMRNANO',
        base: 'XMR',
        quote: 'NANO',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XMRXLM',
        base: 'XMR',
        quote: 'XLM',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XMRLTC',
        base: 'XMR',
        quote: 'LTC',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XMRETH',
        base: 'XMR',
        quote: 'ETH',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'DOGEBTC',
        base: 'DOGE',
        quote: 'BTC',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'DASHETH',
        base: 'DASH',
        quote: 'ETH',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'DASHXVG',
        base: 'DASH',
        quote: 'XVG',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'DASHJPY',
        base: 'DASH',
        quote: 'JPY',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XLMKCS',
        base: 'XLM',
        quote: 'KCS',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XMRKNC',
        base: 'XMR',
        quote: 'KNC',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'NEOLTC',
        base: 'NEO',
        quote: 'LTC',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'NEOKNC',
        base: 'NEO',
        quote: 'KNC',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BDGBIX',
        base: 'BDG',
        quote: 'BIX',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XMRBIX',
        base: 'XMR',
        quote: 'BIX',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'NEOBDG',
        base: 'NEO',
        quote: 'BDG',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'NEOXMR',
        base: 'NEO',
        quote: 'XMR',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'NEODOGE',
        base: 'NEO',
        quote: 'DOGE',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BDGLTC',
        base: 'BDG',
        quote: 'LTC',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'NANOBTC',
        base: 'NANO',
        quote: 'BTC',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XRPBTC',
        base: 'XRP',
        quote: 'BTC',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'USDTNEO',
        base: 'USDT',
        quote: 'NEO',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'USDTNANO',
        base: 'USDT',
        quote: 'NANO',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'USDTXLM',
        base: 'USDT',
        quote: 'XLM',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'NEOETH',
        base: 'NEO',
        quote: 'ETH',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XVGDOGE',
        base: 'XVG',
        quote: 'DOGE',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'DASHDOGE',
        base: 'DASH',
        quote: 'DOGE',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'OMGKCS',
        base: 'OMG',
        quote: 'KCS',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BDGKCS',
        base: 'BDG',
        quote: 'KCS',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'OMGKNC',
        base: 'OMG',
        quote: 'KNC',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'ZECKNC',
        base: 'ZEC',
        quote: 'KNC',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BDGOMG',
        base: 'BDG',
        quote: 'OMG',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XVGOMG',
        base: 'XVG',
        quote: 'OMG',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XRPOMG',
        base: 'XRP',
        quote: 'OMG',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XVGETH',
        base: 'XVG',
        quote: 'ETH',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BNTBCH',
        base: 'BNT',
        quote: 'BCH',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XLMETH',
        base: 'XLM',
        quote: 'ETH',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'USDTBCH',
        base: 'USDT',
        quote: 'BCH',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XRPBCH',
        base: 'XRP',
        quote: 'BCH',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'DASHKCS',
        base: 'DASH',
        quote: 'KCS',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'NEOGBP',
        base: 'NEO',
        quote: 'GBP',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'USDTKCS',
        base: 'USDT',
        quote: 'KCS',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'LTCKCS',
        base: 'LTC',
        quote: 'KCS',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'USDTKNC',
        base: 'USDT',
        quote: 'KNC',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BTCKNC',
        base: 'BTC',
        quote: 'KNC',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'KNCXRP',
        base: 'KNC',
        quote: 'XRP',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BNTXRP',
        base: 'BNT',
        quote: 'XRP',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BNTXVG',
        base: 'BNT',
        quote: 'XVG',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BIXXVG',
        base: 'BIX',
        quote: 'XVG',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'KNCXVG',
        base: 'KNC',
        quote: 'XVG',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'KCSXVG',
        base: 'KCS',
        quote: 'XVG',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BNTJPY',
        base: 'BNT',
        quote: 'JPY',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BIXJPY',
        base: 'BIX',
        quote: 'JPY',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'HTBCH',
        base: 'HT',
        quote: 'BCH',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'KCSBCH',
        base: 'KCS',
        quote: 'BCH',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'USDTDASH',
        base: 'USDT',
        quote: 'DASH',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'USDTXVG',
        base: 'USDT',
        quote: 'XVG',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'HTNANO',
        base: 'HT',
        quote: 'NANO',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XLMDASH',
        base: 'XLM',
        quote: 'DASH',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XLMJPY',
        base: 'XLM',
        quote: 'JPY',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'NANOJPY',
        base: 'NANO',
        quote: 'JPY',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XVGUSDT',
        base: 'XVG',
        quote: 'USDT',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'DASHUSDT',
        base: 'DASH',
        quote: 'USDT',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'DASHEUR',
        base: 'DASH',
        quote: 'EUR',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BCHEUR',
        base: 'BCH',
        quote: 'EUR',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'NEOKCS',
        base: 'NEO',
        quote: 'KCS',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XVGKCS',
        base: 'XVG',
        quote: 'KCS',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BNTKCS',
        base: 'BNT',
        quote: 'KCS',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'HTKCS',
        base: 'HT',
        quote: 'KCS',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'HTKNC',
        base: 'HT',
        quote: 'KNC',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'NANOXVG',
        base: 'NANO',
        quote: 'XVG',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XMRXRP',
        base: 'XMR',
        quote: 'XRP',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'DASHXRP',
        base: 'DASH',
        quote: 'XRP',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BCHXRP',
        base: 'BCH',
        quote: 'XRP',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'KCSXRP',
        base: 'KCS',
        quote: 'XRP',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'NANOXRP',
        base: 'NANO',
        quote: 'XRP',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XLMXRP',
        base: 'XLM',
        quote: 'XRP',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XLMRUB',
        base: 'XLM',
        quote: 'RUB',
        fee_ask: '0.09000000',
        fee_bid: '0.09000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'KCSJPY',
        base: 'KCS',
        quote: 'JPY',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BIXBCH',
        base: 'BIX',
        quote: 'BCH',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'USDTLTC',
        base: 'USDT',
        quote: 'LTC',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'USDTXMR',
        base: 'USDT',
        quote: 'XMR',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'USDTGBP',
        base: 'USDT',
        quote: 'GBP',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XRPGBP',
        base: 'XRP',
        quote: 'GBP',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'USDTOMG',
        base: 'USDT',
        quote: 'OMG',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'HTOMG',
        base: 'HT',
        quote: 'OMG',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'NANOOMG',
        base: 'NANO',
        quote: 'OMG',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'NEOOMG',
        base: 'NEO',
        quote: 'OMG',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'DOGENEO',
        base: 'DOGE',
        quote: 'NEO',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BDGETH',
        base: 'BDG',
        quote: 'ETH',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BDGBCH',
        base: 'BDG',
        quote: 'BCH',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'OMGETH',
        base: 'OMG',
        quote: 'ETH',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'OMGBCH',
        base: 'OMG',
        quote: 'BCH',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XLMUSDT',
        base: 'XLM',
        quote: 'USDT',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'NANOUSDT',
        base: 'NANO',
        quote: 'USDT',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XLMXVG',
        base: 'XLM',
        quote: 'XVG',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'NANOKCS',
        base: 'NANO',
        quote: 'KCS',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'NANOKNC',
        base: 'NANO',
        quote: 'KNC',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XLMKNC',
        base: 'XLM',
        quote: 'KNC',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XLMBNT',
        base: 'XLM',
        quote: 'BNT',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'HTBNT',
        base: 'HT',
        quote: 'BNT',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'HTDOGE',
        base: 'HT',
        quote: 'DOGE',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'HTAUD',
        base: 'HT',
        quote: 'AUD',
        fee_ask: '0.07000000',
        fee_bid: '0.07000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'HTUSD',
        base: 'HT',
        quote: 'USD',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XLMZEC',
        base: 'XLM',
        quote: 'ZEC',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XLMXMR',
        base: 'XLM',
        quote: 'XMR',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XLMDOGE',
        base: 'XLM',
        quote: 'DOGE',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XVGAUD',
        base: 'XVG',
        quote: 'AUD',
        fee_ask: '0.07000000',
        fee_bid: '0.07000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XRPKCS',
        base: 'XRP',
        quote: 'KCS',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XRPKNC',
        base: 'XRP',
        quote: 'KNC',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XVGKNC',
        base: 'XVG',
        quote: 'KNC',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XRPBIX',
        base: 'XRP',
        quote: 'BIX',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XVGBIX',
        base: 'XVG',
        quote: 'BIX',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XRPBNT',
        base: 'XRP',
        quote: 'BNT',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XVGBNT',
        base: 'XVG',
        quote: 'BNT',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XRPHT',
        base: 'XRP',
        quote: 'HT',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XVGHT',
        base: 'XVG',
        quote: 'HT',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XRPNANO',
        base: 'XRP',
        quote: 'NANO',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XRPXLM',
        base: 'XRP',
        quote: 'XLM',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'NEOXVG',
        base: 'NEO',
        quote: 'XVG',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'NANODASH',
        base: 'NANO',
        quote: 'DASH',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XRPDOGE',
        base: 'XRP',
        quote: 'DOGE',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XRPDASH',
        base: 'XRP',
        quote: 'DASH',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XVGXLM',
        base: 'XVG',
        quote: 'XLM',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'NEODASH',
        base: 'NEO',
        quote: 'DASH',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'HTJPY',
        base: 'HT',
        quote: 'JPY',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XVGBCH',
        base: 'XVG',
        quote: 'BCH',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XLMHT',
        base: 'XLM',
        quote: 'HT',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'NEOJPY',
        base: 'NEO',
        quote: 'JPY',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BCHETH',
        base: 'BCH',
        quote: 'ETH',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BCHXVG',
        base: 'BCH',
        quote: 'XVG',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BCHUSDT',
        base: 'BCH',
        quote: 'USDT',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'ETHJPY',
        base: 'ETH',
        quote: 'JPY',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'ETHBCH',
        base: 'ETH',
        quote: 'BCH',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'ETHUSDT',
        base: 'ETH',
        quote: 'USDT',
        fee_ask: '0.03500000',
        fee_bid: '0.03500000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'ETHXRP',
        base: 'ETH',
        quote: 'XRP',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'ETHXVG',
        base: 'ETH',
        quote: 'XVG',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'ETHDASH',
        base: 'ETH',
        quote: 'DASH',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'USDTXRP',
        base: 'USDT',
        quote: 'XRP',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XRPXVG',
        base: 'XRP',
        quote: 'XVG',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XRPAUD',
        base: 'XRP',
        quote: 'AUD',
        fee_ask: '0.07000000',
        fee_bid: '0.07000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XRPEUR',
        base: 'XRP',
        quote: 'EUR',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XRPUSD',
        base: 'XRP',
        quote: 'USD',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XRPUSDT',
        base: 'XRP',
        quote: 'USDT',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XRPETH',
        base: 'XRP',
        quote: 'ETH',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XVGGBP',
        base: 'XVG',
        quote: 'GBP',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'ETHGBP',
        base: 'ETH',
        quote: 'GBP',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BTCZEC',
        base: 'BTC',
        quote: 'ZEC',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BTCLTC',
        base: 'BTC',
        quote: 'LTC',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'NANOAUD',
        base: 'NANO',
        quote: 'AUD',
        fee_ask: '0.07000000',
        fee_bid: '0.07000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'NANOUSD',
        base: 'NANO',
        quote: 'USD',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XLMGBP',
        base: 'XLM',
        quote: 'GBP',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XVGNANO',
        base: 'XVG',
        quote: 'NANO',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'USDTZEC',
        base: 'USDT',
        quote: 'ZEC',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'USDTBTC',
        base: 'USDT',
        quote: 'BTC',
        fee_ask: '0.03500000',
        fee_bid: '0.03500000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'USDTETH',
        base: 'USDT',
        quote: 'ETH',
        fee_ask: '0.03500000',
        fee_bid: '0.03500000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XVGEUR',
        base: 'XVG',
        quote: 'EUR',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XVGXRP',
        base: 'XVG',
        quote: 'XRP',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XVGDASH',
        base: 'XVG',
        quote: 'DASH',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BTCAUD',
        base: 'BTC',
        quote: 'AUD',
        fee_ask: '0.07000000',
        fee_bid: '0.07000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BTCKRW',
        base: 'BTC',
        quote: 'KRW',
        fee_ask: '0.10000000',
        fee_bid: '0.10000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BTCZAR',
        base: 'BTC',
        quote: 'ZAR',
        fee_ask: '0.10000000',
        fee_bid: '0.10000000',
        disabled: false,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BTCKCS',
        base: 'BTC',
        quote: 'KCS',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BTCBIX',
        base: 'BTC',
        quote: 'BIX',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'NANOETH',
        base: 'NANO',
        quote: 'ETH',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XLMNEO',
        base: 'XLM',
        quote: 'NEO',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'LTCXRP',
        base: 'LTC',
        quote: 'XRP',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'LTCBCH',
        base: 'LTC',
        quote: 'BCH',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BTCETH',
        base: 'BTC',
        quote: 'ETH',
        fee_ask: '0.03500000',
        fee_bid: '0.03500000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BTCBCH',
        base: 'BTC',
        quote: 'BCH',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BTCGBP',
        base: 'BTC',
        quote: 'GBP',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BTCJPY',
        base: 'BTC',
        quote: 'JPY',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BTCDASH',
        base: 'BTC',
        quote: 'DASH',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BTCXVG',
        base: 'BTC',
        quote: 'XVG',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BTCXRP',
        base: 'BTC',
        quote: 'XRP',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BTCUSDT',
        base: 'BTC',
        quote: 'USDT',
        fee_ask: '0.03500000',
        fee_bid: '0.03500000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'LTCNANO',
        base: 'LTC',
        quote: 'NANO',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BTCNANO',
        base: 'BTC',
        quote: 'NANO',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'ZECJPY',
        base: 'ZEC',
        quote: 'JPY',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'ZECUSDT',
        base: 'ZEC',
        quote: 'USDT',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'ZECETH',
        base: 'ZEC',
        quote: 'ETH',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'ZECDASH',
        base: 'ZEC',
        quote: 'DASH',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'ZECXVG',
        base: 'ZEC',
        quote: 'XVG',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'ZECKCS',
        base: 'ZEC',
        quote: 'KCS',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'ZECBIX',
        base: 'ZEC',
        quote: 'BIX',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'ZECBNT',
        base: 'ZEC',
        quote: 'BNT',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'ZECHT',
        base: 'ZEC',
        quote: 'HT',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'ZECNANO',
        base: 'ZEC',
        quote: 'NANO',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'ZECXLM',
        base: 'ZEC',
        quote: 'XLM',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'DOGEXVG',
        base: 'DOGE',
        quote: 'XVG',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'DOGEGBP',
        base: 'DOGE',
        quote: 'GBP',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'DOGEETH',
        base: 'DOGE',
        quote: 'ETH',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'DOGEBCH',
        base: 'DOGE',
        quote: 'BCH',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'DOGEJPY',
        base: 'DOGE',
        quote: 'JPY',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'DOGEUSDT',
        base: 'DOGE',
        quote: 'USDT',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'DOGERUB',
        base: 'DOGE',
        quote: 'RUB',
        fee_ask: '0.09000000',
        fee_bid: '0.09000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'DOGEDASH',
        base: 'DOGE',
        quote: 'DASH',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BCHOMG',
        base: 'BCH',
        quote: 'OMG',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'ETHOMG',
        base: 'ETH',
        quote: 'OMG',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BCHKCS',
        base: 'BCH',
        quote: 'KCS',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'ETHKCS',
        base: 'ETH',
        quote: 'KCS',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'ETHKNC',
        base: 'ETH',
        quote: 'KNC',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BCHBIX',
        base: 'BCH',
        quote: 'BIX',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'ETHBIX',
        base: 'ETH',
        quote: 'BIX',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BCHBNT',
        base: 'BCH',
        quote: 'BNT',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'ETHBNT',
        base: 'ETH',
        quote: 'BNT',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BTCBNT',
        base: 'BTC',
        quote: 'BNT',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'DOGEBNT',
        base: 'DOGE',
        quote: 'BNT',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BCHHT',
        base: 'BCH',
        quote: 'HT',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'ETHHT',
        base: 'ETH',
        quote: 'HT',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BTCHT',
        base: 'BTC',
        quote: 'HT',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'DOGEHT',
        base: 'DOGE',
        quote: 'HT',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BCHNANO',
        base: 'BCH',
        quote: 'NANO',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'ETHNANO',
        base: 'ETH',
        quote: 'NANO',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'DOGENANO',
        base: 'DOGE',
        quote: 'NANO',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'ETHXLM',
        base: 'ETH',
        quote: 'XLM',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BTCXLM',
        base: 'BTC',
        quote: 'XLM',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'LTCOMG',
        base: 'LTC',
        quote: 'OMG',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'ZECOMG',
        base: 'ZEC',
        quote: 'OMG',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XMROMG',
        base: 'XMR',
        quote: 'OMG',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'DOGEOMG',
        base: 'DOGE',
        quote: 'OMG',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BTCOMG',
        base: 'BTC',
        quote: 'OMG',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'KCSRUB',
        base: 'KCS',
        quote: 'RUB',
        fee_ask: '0.09000000',
        fee_bid: '0.09000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BIXKCS',
        base: 'BIX',
        quote: 'KCS',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'KNCKCS',
        base: 'KNC',
        quote: 'KCS',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BIXKNC',
        base: 'BIX',
        quote: 'KNC',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'KCSKNC',
        base: 'KCS',
        quote: 'KNC',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'KNCBIX',
        base: 'KNC',
        quote: 'BIX',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'KCSBIX',
        base: 'KCS',
        quote: 'BIX',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'KCSBNT',
        base: 'KCS',
        quote: 'BNT',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'KCSXLM',
        base: 'KCS',
        quote: 'XLM',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BDGKNC',
        base: 'BDG',
        quote: 'KNC',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'NANOBIX',
        base: 'NANO',
        quote: 'BIX',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BDGRUB',
        base: 'BDG',
        quote: 'RUB',
        fee_ask: '0.09000000',
        fee_bid: '0.09000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'KCSAUD',
        base: 'KCS',
        quote: 'AUD',
        fee_ask: '0.07000000',
        fee_bid: '0.07000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'KNCAUD',
        base: 'KNC',
        quote: 'AUD',
        fee_ask: '0.07000000',
        fee_bid: '0.07000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BIXAUD',
        base: 'BIX',
        quote: 'AUD',
        fee_ask: '0.07000000',
        fee_bid: '0.07000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BNTAUD',
        base: 'BNT',
        quote: 'AUD',
        fee_ask: '0.07000000',
        fee_bid: '0.07000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'LTCAUD',
        base: 'LTC',
        quote: 'AUD',
        fee_ask: '0.07000000',
        fee_bid: '0.07000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'LTCKRW',
        base: 'LTC',
        quote: 'KRW',
        fee_ask: '0.10000000',
        fee_bid: '0.10000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'LTCZAR',
        base: 'LTC',
        quote: 'ZAR',
        fee_ask: '0.10000000',
        fee_bid: '0.10000000',
        disabled: false,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XMRAUD',
        base: 'XMR',
        quote: 'AUD',
        fee_ask: '0.07000000',
        fee_bid: '0.07000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'DOGEAUD',
        base: 'DOGE',
        quote: 'AUD',
        fee_ask: '0.07000000',
        fee_bid: '0.07000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BCHAUD',
        base: 'BCH',
        quote: 'AUD',
        fee_ask: '0.07000000',
        fee_bid: '0.07000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'ETHAUD',
        base: 'ETH',
        quote: 'AUD',
        fee_ask: '0.07000000',
        fee_bid: '0.07000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BNTBTC',
        base: 'BNT',
        quote: 'BTC',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BIXBTC',
        base: 'BIX',
        quote: 'BTC',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'KNCBTC',
        base: 'KNC',
        quote: 'BTC',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'KCSBTC',
        base: 'KCS',
        quote: 'BTC',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BDGBTC',
        base: 'BDG',
        quote: 'BTC',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'OMGBTC',
        base: 'OMG',
        quote: 'BTC',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BNTZEC',
        base: 'BNT',
        quote: 'ZEC',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BIXZEC',
        base: 'BIX',
        quote: 'ZEC',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'KNCZEC',
        base: 'KNC',
        quote: 'ZEC',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'KCSZEC',
        base: 'KCS',
        quote: 'ZEC',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'NANOZEC',
        base: 'NANO',
        quote: 'ZEC',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'KCSNEO',
        base: 'KCS',
        quote: 'NEO',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'HTNEO',
        base: 'HT',
        quote: 'NEO',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BDGNEO',
        base: 'BDG',
        quote: 'NEO',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'OMGNEO',
        base: 'OMG',
        quote: 'NEO',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'NEOZEC',
        base: 'NEO',
        quote: 'ZEC',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BDGZEC',
        base: 'BDG',
        quote: 'ZEC',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'OMGZEC',
        base: 'OMG',
        quote: 'ZEC',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'KCSOMG',
        base: 'KCS',
        quote: 'OMG',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'KNCOMG',
        base: 'KNC',
        quote: 'OMG',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BIXOMG',
        base: 'BIX',
        quote: 'OMG',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BNTOMG',
        base: 'BNT',
        quote: 'OMG',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'NANOBDG',
        base: 'NANO',
        quote: 'BDG',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'HTBDG',
        base: 'HT',
        quote: 'BDG',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BNTBDG',
        base: 'BNT',
        quote: 'BDG',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BIXBDG',
        base: 'BIX',
        quote: 'BDG',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'KNCBDG',
        base: 'KNC',
        quote: 'BDG',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XVGXMR',
        base: 'XVG',
        quote: 'XMR',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'DASHBTC',
        base: 'DASH',
        quote: 'BTC',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'DASHLTC',
        base: 'DASH',
        quote: 'LTC',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'DASHZEC',
        base: 'DASH',
        quote: 'ZEC',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'DASHXMR',
        base: 'DASH',
        quote: 'XMR',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BCHZEC',
        base: 'BCH',
        quote: 'ZEC',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BCHLTC',
        base: 'BCH',
        quote: 'LTC',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BCHBTC',
        base: 'BCH',
        quote: 'BTC',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BCHXMR',
        base: 'BCH',
        quote: 'XMR',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BCHCAD',
        base: 'BCH',
        quote: 'CAD',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BCHDOGE',
        base: 'BCH',
        quote: 'DOGE',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'ETHBTC',
        base: 'ETH',
        quote: 'BTC',
        fee_ask: '0.03500000',
        fee_bid: '0.03500000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XVGBTC',
        base: 'XVG',
        quote: 'BTC',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XVGLTC',
        base: 'XVG',
        quote: 'LTC',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XVGZEC',
        base: 'XVG',
        quote: 'ZEC',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'OMGDASH',
        base: 'OMG',
        quote: 'DASH',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'OMGXVG',
        base: 'OMG',
        quote: 'XVG',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'OMGXRP',
        base: 'OMG',
        quote: 'XRP',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'OMGUSDT',
        base: 'OMG',
        quote: 'USDT',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'OMGUSD',
        base: 'OMG',
        quote: 'USD',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'OMGEUR',
        base: 'OMG',
        quote: 'EUR',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'ZECUSD',
        base: 'ZEC',
        quote: 'USD',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'ZECEUR',
        base: 'ZEC',
        quote: 'EUR',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'ETHUSD',
        base: 'ETH',
        quote: 'USD',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'ETHEUR',
        base: 'ETH',
        quote: 'EUR',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BTCUSD',
        base: 'BTC',
        quote: 'USD',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BTCEUR',
        base: 'BTC',
        quote: 'EUR',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'LTCEUR',
        base: 'LTC',
        quote: 'EUR',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BDGJPY',
        base: 'BDG',
        quote: 'JPY',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BDGDASH',
        base: 'BDG',
        quote: 'DASH',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BDGXVG',
        base: 'BDG',
        quote: 'XVG',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BDGXRP',
        base: 'BDG',
        quote: 'XRP',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BDGUSDT',
        base: 'BDG',
        quote: 'USDT',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BDGUSD',
        base: 'BDG',
        quote: 'USD',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BDGEUR',
        base: 'BDG',
        quote: 'EUR',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'OMGJPY',
        base: 'OMG',
        quote: 'JPY',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'LTCBTC',
        base: 'LTC',
        quote: 'BTC',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'LTCZEC',
        base: 'LTC',
        quote: 'ZEC',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'LTCXMR',
        base: 'LTC',
        quote: 'XMR',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BCHGBP',
        base: 'BCH',
        quote: 'GBP',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'ETHZAR',
        base: 'ETH',
        quote: 'ZAR',
        fee_ask: '0.10000000',
        fee_bid: '0.10000000',
        disabled: false,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'ETHKRW',
        base: 'ETH',
        quote: 'KRW',
        fee_ask: '0.10000000',
        fee_bid: '0.10000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BTCDOGE',
        base: 'BTC',
        quote: 'DOGE',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BTCCAD',
        base: 'BTC',
        quote: 'CAD',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BTCXMR',
        base: 'BTC',
        quote: 'XMR',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'DASHOMG',
        base: 'DASH',
        quote: 'OMG',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BCHKNC',
        base: 'BCH',
        quote: 'KNC',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'DASHKNC',
        base: 'DASH',
        quote: 'KNC',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'DASHBIX',
        base: 'DASH',
        quote: 'BIX',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'DASHBNT',
        base: 'DASH',
        quote: 'BNT',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'DASHHT',
        base: 'DASH',
        quote: 'HT',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'DASHNANO',
        base: 'DASH',
        quote: 'NANO',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BCHXLM',
        base: 'BCH',
        quote: 'XLM',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BDGBNT',
        base: 'BDG',
        quote: 'BNT',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BDGHT',
        base: 'BDG',
        quote: 'HT',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BNTNANO',
        base: 'BNT',
        quote: 'NANO',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BIXNANO',
        base: 'BIX',
        quote: 'NANO',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'KNCNANO',
        base: 'KNC',
        quote: 'NANO',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'KCSNANO',
        base: 'KCS',
        quote: 'NANO',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'NEONANO',
        base: 'NEO',
        quote: 'NANO',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'OMGNANO',
        base: 'OMG',
        quote: 'NANO',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'KCSGBP',
        base: 'KCS',
        quote: 'GBP',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'KNCGBP',
        base: 'KNC',
        quote: 'GBP',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BIXGBP',
        base: 'BIX',
        quote: 'GBP',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BNTGBP',
        base: 'BNT',
        quote: 'GBP',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'HTGBP',
        base: 'HT',
        quote: 'GBP',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'NANOGBP',
        base: 'NANO',
        quote: 'GBP',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BDGGBP',
        base: 'BDG',
        quote: 'GBP',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'OMGGBP',
        base: 'OMG',
        quote: 'GBP',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'ETHXMR',
        base: 'ETH',
        quote: 'XMR',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'ETHCAD',
        base: 'ETH',
        quote: 'CAD',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'ETHDOGE',
        base: 'ETH',
        quote: 'DOGE',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'LTCETH',
        base: 'LTC',
        quote: 'ETH',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'LTCGBP',
        base: 'LTC',
        quote: 'GBP',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'LTCJPY',
        base: 'LTC',
        quote: 'JPY',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'LTCDASH',
        base: 'LTC',
        quote: 'DASH',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'LTCXVG',
        base: 'LTC',
        quote: 'XVG',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'LTCUSDT',
        base: 'LTC',
        quote: 'USDT',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'ZECXRP',
        base: 'ZEC',
        quote: 'XRP',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'ZECAUD',
        base: 'ZEC',
        quote: 'AUD',
        fee_ask: '0.07000000',
        fee_bid: '0.07000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'ZECGBP',
        base: 'ZEC',
        quote: 'GBP',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'ZECBCH',
        base: 'ZEC',
        quote: 'BCH',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'LTCXLM',
        base: 'LTC',
        quote: 'XLM',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'KCSBDG',
        base: 'KCS',
        quote: 'BDG',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XMRBDG',
        base: 'XMR',
        quote: 'BDG',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'DOGEBDG',
        base: 'DOGE',
        quote: 'BDG',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XRPBDG',
        base: 'XRP',
        quote: 'BDG',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XVGBDG',
        base: 'XVG',
        quote: 'BDG',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'DASHBDG',
        base: 'DASH',
        quote: 'BDG',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BCHBDG',
        base: 'BCH',
        quote: 'BDG',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'LTCBDG',
        base: 'LTC',
        quote: 'BDG',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BTCBDG',
        base: 'BTC',
        quote: 'BDG',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'USDTBDG',
        base: 'USDT',
        quote: 'BDG',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'ETHBDG',
        base: 'ETH',
        quote: 'BDG',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'HTRUB',
        base: 'HT',
        quote: 'RUB',
        fee_ask: '0.09000000',
        fee_bid: '0.09000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BIXNEO',
        base: 'BIX',
        quote: 'NEO',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'NEOBNT',
        base: 'NEO',
        quote: 'BNT',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'NEOHT',
        base: 'NEO',
        quote: 'HT',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'NANOEUR',
        base: 'NANO',
        quote: 'EUR',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'HTEUR',
        base: 'HT',
        quote: 'EUR',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BNTEUR',
        base: 'BNT',
        quote: 'EUR',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'KCSETH',
        base: 'KCS',
        quote: 'ETH',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'KNCETH',
        base: 'KNC',
        quote: 'ETH',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BIXETH',
        base: 'BIX',
        quote: 'ETH',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BNTETH',
        base: 'BNT',
        quote: 'ETH',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'HTETH',
        base: 'HT',
        quote: 'ETH',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'NANOBNT',
        base: 'NANO',
        quote: 'BNT',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BIXHT',
        base: 'BIX',
        quote: 'HT',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'KCSHT',
        base: 'KCS',
        quote: 'HT',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'KNCHT',
        base: 'KNC',
        quote: 'HT',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'NANOHT',
        base: 'NANO',
        quote: 'HT',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BNTHT',
        base: 'BNT',
        quote: 'HT',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XLMOMG',
        base: 'XLM',
        quote: 'OMG',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XLMBDG',
        base: 'XLM',
        quote: 'BDG',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XLMBTC',
        base: 'XLM',
        quote: 'BTC',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'NANOLTC',
        base: 'NANO',
        quote: 'LTC',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XLMLTC',
        base: 'XLM',
        quote: 'LTC',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'NEOXLM',
        base: 'NEO',
        quote: 'XLM',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'OMGXLM',
        base: 'OMG',
        quote: 'XLM',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BDGXLM',
        base: 'BDG',
        quote: 'XLM',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'KNCXLM',
        base: 'KNC',
        quote: 'XLM',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BNTXLM',
        base: 'BNT',
        quote: 'XLM',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'NANOXLM',
        base: 'NANO',
        quote: 'XLM',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'HTXLM',
        base: 'HT',
        quote: 'XLM',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BIXXLM',
        base: 'BIX',
        quote: 'XLM',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XMRUSD',
        base: 'XMR',
        quote: 'USD',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XMREUR',
        base: 'XMR',
        quote: 'EUR',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'DOGEUSD',
        base: 'DOGE',
        quote: 'USD',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'USDTUSD',
        base: 'USDT',
        quote: 'USD',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'USDTEUR',
        base: 'USDT',
        quote: 'EUR',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XVGUSD',
        base: 'XVG',
        quote: 'USD',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'DASHUSD',
        base: 'DASH',
        quote: 'USD',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BCHUSD',
        base: 'BCH',
        quote: 'USD',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'KNCBNT',
        base: 'KNC',
        quote: 'BNT',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'ZECRUB',
        base: 'ZEC',
        quote: 'RUB',
        fee_ask: '0.09000000',
        fee_bid: '0.09000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'ZECBDG',
        base: 'ZEC',
        quote: 'BDG',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'DOGEXRP',
        base: 'DOGE',
        quote: 'XRP',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'DOGEXMR',
        base: 'DOGE',
        quote: 'XMR',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'DOGEKCS',
        base: 'DOGE',
        quote: 'KCS',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'DOGEKNC',
        base: 'DOGE',
        quote: 'KNC',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'DOGEBIX',
        base: 'DOGE',
        quote: 'BIX',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'DOGEXLM',
        base: 'DOGE',
        quote: 'XLM',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'ZECLTC',
        base: 'ZEC',
        quote: 'LTC',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XMRZEC',
        base: 'XMR',
        quote: 'ZEC',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'DOGELTC',
        base: 'DOGE',
        quote: 'LTC',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'DOGEZEC',
        base: 'DOGE',
        quote: 'ZEC',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'ETHLTC',
        base: 'ETH',
        quote: 'LTC',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'ETHZEC',
        base: 'ETH',
        quote: 'ZEC',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'HTBTC',
        base: 'HT',
        quote: 'BTC',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'HTLTC',
        base: 'HT',
        quote: 'LTC',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'HTZEC',
        base: 'HT',
        quote: 'ZEC',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'HTXMR',
        base: 'HT',
        quote: 'XMR',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'NANORUB',
        base: 'NANO',
        quote: 'RUB',
        fee_ask: '0.09000000',
        fee_bid: '0.09000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'DASHRUB',
        base: 'DASH',
        quote: 'RUB',
        fee_ask: '0.09000000',
        fee_bid: '0.09000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'NANONEO',
        base: 'NANO',
        quote: 'NEO',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'DASHNEO',
        base: 'DASH',
        quote: 'NEO',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XVGRUB',
        base: 'XVG',
        quote: 'RUB',
        fee_ask: '0.09000000',
        fee_bid: '0.09000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BTCRUB',
        base: 'BTC',
        quote: 'RUB',
        fee_ask: '0.09000000',
        fee_bid: '0.09000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XMRBTC',
        base: 'XMR',
        quote: 'BTC',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XMRRUB',
        base: 'XMR',
        quote: 'RUB',
        fee_ask: '0.09000000',
        fee_bid: '0.09000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'ETHRUB',
        base: 'ETH',
        quote: 'RUB',
        fee_ask: '0.09000000',
        fee_bid: '0.09000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'KNCRUB',
        base: 'KNC',
        quote: 'RUB',
        fee_ask: '0.09000000',
        fee_bid: '0.09000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BIXRUB',
        base: 'BIX',
        quote: 'RUB',
        fee_ask: '0.09000000',
        fee_bid: '0.09000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BIXUSD',
        base: 'BIX',
        quote: 'USD',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'LTCUSD',
        base: 'LTC',
        quote: 'USD',
        fee_ask: '0.05000000',
        fee_bid: '0.05000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'LTCRUB',
        base: 'LTC',
        quote: 'RUB',
        fee_ask: '0.09000000',
        fee_bid: '0.09000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'BCHRUB',
        base: 'BCH',
        quote: 'RUB',
        fee_ask: '0.09000000',
        fee_bid: '0.09000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XLMBCH',
        base: 'XLM',
        quote: 'BCH',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'KNCBCH',
        base: 'KNC',
        quote: 'BCH',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'NANOBCH',
        base: 'NANO',
        quote: 'BCH',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'DASHBCH',
        base: 'DASH',
        quote: 'BCH',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'USDTRUB',
        base: 'USDT',
        quote: 'RUB',
        fee_ask: '0.09000000',
        fee_bid: '0.09000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'NEORUB',
        base: 'NEO',
        quote: 'RUB',
        fee_ask: '0.09000000',
        fee_bid: '0.09000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'XRPRUB',
        base: 'XRP',
        quote: 'RUB',
        fee_ask: '0.09000000',
        fee_bid: '0.09000000',
        disabled: false,
        test_mode: false,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'NEOBTC',
        base: 'NEO',
        quote: 'BTC',
        fee_ask: '0.04000000',
        fee_bid: '0.04000000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'NEOXRP',
        base: 'NEO',
        quote: 'XRP',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
    {
        name: 'NEOBCH',
        base: 'NEO',
        quote: 'BCH',
        fee_ask: '0.04500000',
        fee_bid: '0.04500000',
        disabled: true,
        test_mode: true,
        orderbook_enabled: false,
        reverse_orderbook_enabled: false,
    },
]
